/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * HelpScout
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var self = Astoundify.HelpScout = _.extend( {}, {
		apiBase: '.helpscoutdocs.com/search/ajax?ref=astoundify-faq&query=',
		form: '#helpscout-search',
		$form: $( '#helpscout-search' ),
		$resultsContainer: $( '#helpscout-results' ),
		resultTemplate: 'helpscoutDocResult'
	}, Astoundify.HelPScout || {} );

	$.fn.bindWithDelay = function( type, data, fn, timeout, throttle ) {
			if ( $.isFunction( data ) ) {
					throttle = timeout;
					timeout = fn;
					fn = data;
					data = undefined;
			}

			// Allow delayed function to be removed with fn in unbind function
			fn.guid = fn.guid || ($.guid && $.guid++);

			// Bind each separately so that each element has its own delay
			return this.each(function() {
					var wait = null;

					function cb() {
							var e = $.extend(true, { }, arguments[0]);
							var ctx = this;
							var throttler = function() {
									wait = null;
									fn.apply(ctx, [e]);
							};

							if (!throttle) { clearTimeout(wait); wait = null; }
							if (!wait) { wait = setTimeout(throttler, timeout); }
					}

					cb.guid = fn.guid;

					$(this).bind(type, data, cb);
			});
	};

	/**
	 * Search Field.
	 *
	 * Found within within the defined form.
	 *
	 * @since 1.0.0
	 * @type {object}
	 */
	var $searchField = self.$form.find( 'input[type="search"]' );

	/**
	 * Perform a search.
	 *
	 * @since 1.0.0
	 */
	var performSearch = function(e) {
		if ( '' == $searchField.val() ) {
			return removeResults();
		}

		var search = $.ajax({
			url: 'https://' + self.$form.data( 'subdomain' ) + self.apiBase + $searchField.val(),
			dataType: 'json',
			type: 'GET',
		})
		.done( appendResults )
		.fail( appendError );
	}

	/**
	 * Append results.
	 *
	 * @since 1.0.0
	 *
	 * @param object response
	 */
	var appendResults = function( response ) {
		var results = response.articles.results.splice(0, 5);
		var template = wp.template( self.resultTemplate );

		self.$resultsContainer.show().html( '' );

		results.forEach( function( result ) {
			self.$resultsContainer.append( template( result ) );
		});

		self.$resultsContainer.append( '<li class="helpscout-search-results__result helpscout-search-results__result--more"><a href="' + self.$form.attr( 'action' ) + $searchField.val() + '">View More &rarr;</a></li>' );
	}

	/**
	 * Append error.
	 *
	 * @since 1.0.0
	 *
	 * @param object response
	 */
	var appendError = function( response ) {
		self.$resultsContainer.html( '<li class="helpscout-search-results__result helpscout-search-results__result-error">No articles found</li>' );
	}

	/**
	 * Remove results
	 *
	 * @since 1.0.0
	 *
	 * @param object response
	 */
	var removeResults = function( response ) {
		self.$resultsContainer.hide().html( '' );
	}

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		// Block "Enter" or Submit button from submitting the form.
		self.$form.on( 'keypress', function( e ) {
			var code = e.which || e.keyCode;

			if ( 13 === code ) {
				e.preventDefault();

				performSearch(e);
			}
		});

		// Search
		$searchField.bindWithDelay( 'keyup', performSearch, 500 );

		// Make ticket clickable.
		$( '.hst-conversation-item' ).click( function(e) {
			window.document.location = $( this ).data( "href" );
		});
	});

})( jQuery );
